import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_cursor_hand.svg';
import Icon, { IconProps } from './icon';

const IconCursorHand = (props: IconProps & { id?: string }) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconCursorHand;
